import useLogisticsDriversView from './useLogisticsDriversView';

export { useLogisticsDriversView };
